import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// React router
import { BrowserRouter } from 'react-router-dom';
//import { TMUAPI, API } from './context';

// Require PureCSS... must come after 
// imports or error
// require('wingcss');
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/custom.css';
import {datadogRum} from '@datadog/browser-rum';
import {reactPlugin} from '@datadog/browser-rum-react';

if (process.env.REACT_APP_DD_RUM_ENABLED.toLowerCase() === 'true'){
    datadogRum.init({
        applicationId: process.env.REACT_APP_DD_RUM_APPID,
        clientToken: process.env.REACT_APP_DD_RUM_TOKEN,
        site: process.env.REACT_APP_DD_RUM_SITE,
        service: process.env.REACT_APP_DD_RUM_SERVICE,
        env: process.env.REACT_APP_DD_RUM_ENV,
        sessionSampleRate: 100,
        defaultPrivacyLevel: "mask-user-input",
        allowedTracingUrls: [
            process.env.REACT_APP_DD_RUM_TRACE_URL
        ],
        plugins: [reactPlugin({router: true})],
    });
}
ReactDOM.createRoot(document.getElementById("root")).render(<BrowserRouter><App/></BrowserRouter>)

reportWebVitals();
